/**
 * Pure validation helpers shared by Anna registration and its tests.
 * Keeping these rules outside the screen prevents the UI and tests from
 * silently drifting apart.
 */

/** Normalize an Indian vehicle registration for storage and comparison. */
export const sanitizeVehicleNumber = (raw) =>
  String(raw || '').trim().toUpperCase().replace(/[\s-]/g, '');

/**
 * Indian registration format: state code, RTO code, optional series letters,
 * and the four-digit sequence (for example AP39TG4838).
 */
export const isValidVehicleNumber = (raw) => {
  const clean = sanitizeVehicleNumber(raw);
  return /^[A-Z]{2}[0-9]{1,2}[A-Z]{0,3}[0-9]{4}$/.test(clean);
};

/** Returning Annas must not be sent back through first-time registration. */
export const isProfileComplete = (profile) => Boolean(
  profile?.isApproved === true
  || profile?.name?.trim()
  || profile?.vehicleNumber?.trim()
  || profile?.profileComplete === true
);

/** Validate and normalize the payload written by the registration screen. */
export const validateKycPayload = ({ name, vehicleNumber, photoUrl, vehiclePhotoUrl }) => {
  const cleanName = String(name || '').trim();
  const cleanVehicle = sanitizeVehicleNumber(vehicleNumber);

  if (!cleanName || cleanName.length < 2) {
    return { valid: false, error: 'Valid name required' };
  }
  if (!isValidVehicleNumber(cleanVehicle)) {
    return { valid: false, error: 'Valid vehicle registration number required' };
  }

  return {
    valid: true,
    normalized: {
      name: cleanName,
      vehicleNumber: cleanVehicle,
      photoUrl: photoUrl || null,
      vehiclePhotoUrl: vehiclePhotoUrl || null,
      profileComplete: true,
    },
  };
};
